import React, { lazy, Suspense } from 'react';
import { Route, Redirect, BrowserRouter as Router, Switch, } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';
import { PUBLIC_ROUTE } from './route.constants';
import Loader from '@iso/components/utility/loader';


const Dashboard = lazy(() => import('./containers/Dashboard/Dashboard'));

const publicRoutes = [
  {
    path: PUBLIC_ROUTE.LANDING,
    exact: true,
    component: lazy(() => import('@iso/containers/Pages/SignUp/SignUp')),
  },
  {
    path: PUBLIC_ROUTE.PAGE_404,
    component: lazy(() => import('@iso/containers/Pages/404/404')),
  },
  {
    path: PUBLIC_ROUTE.PAGE_500,
    component: lazy(() => import('@iso/containers/Pages/500/500')),
  },
  {
    path: PUBLIC_ROUTE.SIGN_IN,
    component: lazy(() => import('@iso/containers/Pages/SignIn/SignIn')),
  },
  {
    path: PUBLIC_ROUTE.SIGN_UP,
    component: lazy(() => import('@iso/containers/Pages/SignUp/SignUp')),
  },
  {
    path: PUBLIC_ROUTE.OTP_VERIFICATION,
    component: lazy(() => import('@iso/containers/Pages/OtpVerification/OtpVerification')),
  },
  {
    path: PUBLIC_ROUTE.FORGET_PASSWORD,
    component: lazy(() => import('@iso/containers/Pages/ResetPassword/ResetPassword')),
  },
  {
    path: PUBLIC_ROUTE.RESET_PASSWORD,
    component: lazy(() => import('@iso/containers/Pages/ForgotPassword/ForgotPassword')),
  },
  {
    path: PUBLIC_ROUTE.AUTH0_CALLBACK,
    component: lazy(() => import('@iso/containers/Authentication/Auth0/Auth0Callback')),
  },
  {
    path: PUBLIC_ROUTE.PLACE_REVIEW,
    component: lazy(() => import('@iso/containers/Pages/Test/PlaceReview')),
  },
  {
    path: PUBLIC_ROUTE.HEAT_MAP,
    component: lazy(() => import('@iso/containers/Pages/Test/HeatMap')),
  },
  {
    path: PUBLIC_ROUTE.PLACE_BOUNDARY,
    component: lazy(() => import('@iso/containers/Pages/Test/PlaceBoundary')),
  },
  {
    path: PUBLIC_ROUTE.AUTO_TURF,
    component: lazy(() => import('@iso/containers/Pages/Test/MapWithAutoTurf')),
  },
  {
    path: PUBLIC_ROUTE.AUTO_TURF_MEANS,
    component: lazy(() => import('@iso/containers/Pages/Test/AutoTurfKMeans')),
  },
];

function PublicRoute({ children, ...rest }) {
  const isLoggedIn = sessionStorage.getItem("Token");

  return (
    <Route
      {...rest}
      render={
        ({ location }) => (
          !isLoggedIn ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: location }
              }}
            />
          ))
      }
    />
  );
}

function PrivateRoute({ children, ...rest }) {
  const isLoggedIn = sessionStorage.getItem("Token");

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLoggedIn ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default function Routes() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <Router >
          <Switch>

            {publicRoutes.map((route, index) => {
              return (
                <PublicRoute key={index} path={route.path} exact={route.exact} component={route.component}>
                </PublicRoute>
              )
            })}

            <PrivateRoute path="/dashboard">
              <Dashboard />
            </PrivateRoute>

            <Route path={"*"} component={lazy(() => import('@iso/containers/Pages/404/404'))} />

          </Switch>
        </Router>
      </Suspense>
    </ErrorBoundary>
  );
}
